import { Plus, Trash2 } from "lucide-react";
import { TimeSelect } from "../calendar/DateField";

// Editable list of {start,end} windows
export function WindowsEditor({ windows, onChange, testId }) {
  const set = (i, k, v) => onChange(windows.map((w, j) => (j === i ? { ...w, [k]: v } : w)));
  return (
    <div className="flex flex-wrap items-center gap-2" data-testid={testId}>
      {windows.map((w, i) => (
        <div key={i} className="flex items-center gap-1 bg-[#0A0A0A] border border-white/10 px-1">
          <TimeSelect value={w.start} onChange={(v) => set(i, "start", v)} testId={`${testId}-start-${i}`} />
          <span className="text-[#71717A]">–</span>
          <TimeSelect value={w.end} onChange={(v) => set(i, "end", v)} testId={`${testId}-end-${i}`} />
          <button type="button" onClick={() => onChange(windows.filter((_, j) => j !== i))} className="text-[#71717A] hover:text-red-400 p-1" data-testid={`${testId}-remove-${i}`}><Trash2 className="w-3.5 h-3.5" /></button>
        </div>
      ))}
      <button type="button" onClick={() => onChange([...windows, { start: "16:00", end: "20:00" }])} className="text-xs text-[#c1ff72] flex items-center gap-1 hover:underline" data-testid={`${testId}-add`}><Plus className="w-3.5 h-3.5" />Zeitfenster</button>
      {!windows.length && <span className="text-xs text-red-300">nicht buchbar</span>}
    </div>
  );
}
